/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Icon } from '@zapier/zinnia-icons';
import { Tooltip, TooltipFocusableTrigger } from '@zapier/design-system';
import { ComponentProps, ReactNode } from 'react';

const styleRoot = css`
  display: inline-block;
`;

const styleFlex = css`
  display: flex;
`;

interface InfoIconTooltipProps {
  allowMultilineTooltip?: boolean;
  content: ReactNode;
  position?: ComponentProps<typeof Tooltip>['placement'];
  size?: string;
}

export function InfoIconTooltip({
  allowMultilineTooltip,
  content,
  position,
  size = '20px',
}: InfoIconTooltipProps) {
  return (
    <div css={styleRoot}>
      <Tooltip
        allowMultiline={allowMultilineTooltip}
        content={typeof content === 'string' ? content : ''}
        placement={position}
      >
        <TooltipFocusableTrigger>
          <div css={styleFlex}>
            <Icon color="GrayWarm6" name="alertInfoFill" size={size} />
          </div>
        </TooltipFocusableTrigger>
      </Tooltip>
    </div>
  );
}
